import { render, staticRenderFns } from "./specialDataListOPC.vue?vue&type=template&id=03b4c934&"
import script from "./specialDataListOPC.vue?vue&type=script&lang=js&"
export * from "./specialDataListOPC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports